import { render, staticRenderFns } from "./economyStretchMobile.vue?vue&type=template&id=128a6ad8&scoped=true&"
import script from "./economyStretchMobile.vue?vue&type=script&lang=js&"
export * from "./economyStretchMobile.vue?vue&type=script&lang=js&"
import style0 from "./economyStretchMobile.vue?vue&type=style&index=0&id=128a6ad8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a6ad8",
  null
  
)

export default component.exports